import { render, staticRenderFns } from "./LetterCube.vue?vue&type=template&id=248d4145&scoped=true"
import script from "./LetterCube.vue?vue&type=script&lang=js"
export * from "./LetterCube.vue?vue&type=script&lang=js"
import style0 from "./LetterCube.vue?vue&type=style&index=0&id=248d4145&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d4145",
  null
  
)

export default component.exports